// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"c47edb5b","466":"4266ef74"}[chunkId] + ".chunk.js";
};